function create_custom_shortby_dropdown() {
  $(".sort-by select").each(function (i, select) {
    if (!$(this).next().hasClass("dropdown")) {
      $(this).after(
        '<div class="dropdown ' +
          ($(this).attr("class") || "") +
          '" tabindex="0"><span class="current"></span><div class="list"><ul></ul></div></div>'
      );
      var dropdown = $(this).next();
      var options = $(select).find("option");
      var selected = $(this).find("option:selected");
      dropdown
        .find(".current")
        .html(selected.data("display-text") || selected.text());
      options.each(function (j, o) {
        var display = $(o).data("display-text") || "";
        dropdown
          .find("ul")
          .append(
            '<li class="option ' +
              ($(o).is(":selected") ? "selected" : "") +
              '" data-value="' +
              $(o).val() +
              '" data-display-text="' +
              display +
              '">' +
              $(o).text() +
              "</li>"
          );
      });
    }
  });
}

// Event listeners

// Open/close
$(".sort-by").on("click", ".dropdown", function (event) {
  $(".sort-by .dropdown").not($(this)).removeClass("open");
  $(this).toggleClass("open");
  if ($(this).hasClass("open")) {
    $(this).find(".option").attr("tabindex", 0);
    $(this).find(".selected").focus();
  } else {
    $(this).find(".option").removeAttr("tabindex");
    $(this).focus();
  }
});
// Close when clicking outside
$(document).on("click", function (event) {
  if ($(event.target).closest(".dropdown").length === 0) {
    $(".sort-by .dropdown").removeClass("open");
    $(".sort-by .dropdown .option").removeAttr("tabindex");
  }
  event.stopPropagation();
});
// Option click
$(".sort-by").on("click", ".dropdown .option", async function (event) {
  $("#resultLoading").show();
  $(this).closest(".list").find(".selected").removeClass("selected");
  $(this).addClass("selected");
  var text = $(this).data("display-text") || $(this).text();
  var value = $(this).data("value");
  $(this).closest(".dropdown").find(".current").text(text);
  $(this)
    .closest(".dropdown")
    .prev("select")
    .val($(this).data("value"))
    .trigger("change");

  //Sort products ajax
  let newUrl = updateURLParameter(window.location.href, "sort_by", value);
  let productRes = await fetch(newUrl);
  productRes = await productRes.text();
  let parser = new DOMParser();
  let doc = parser.parseFromString(productRes, "text/html");
  let girdUpdate = doc.querySelector("#products-grid").innerHTML;
  document.querySelector("#products-grid").innerHTML = girdUpdate;
  window.history.pushState({ path: newUrl }, "", newUrl);
  addToCart();
  productGridReview();
  __rt.enabled_wishlist?__kpWishlist(): null;
  $("#resultLoading").hide();
});

// Keyboard events
$(".sort-by").on("keydown", ".dropdown", function (event) {
  var focused_option = $(
    $(this).find(".list .option:focus")[0] ||
      $(this).find(".list .option.selected")[0]
  );
  // Space or Enter
  if (event.keyCode == 32 || event.keyCode == 13) {
    if ($(this).hasClass("open")) {
      focused_option.trigger("click");
    } else {
      $(this).trigger("click");
    }
    return false;
    // Down
  } else if (event.keyCode == 40) {
    if (!$(this).hasClass("open")) {
      $(this).trigger("click");
    } else {
      focused_option.next().focus();
    }
    return false;
    // Up
  } else if (event.keyCode == 38) {
    if (!$(this).hasClass("open")) {
      $(this).trigger("click");
    } else {
      var focused_option = $(
        $(this).find(".list .option:focus")[0] ||
          $(this).find(".list .option.selected")[0]
      );
      focused_option.prev().focus();
    }
    return false;
    // Esc
  } else if (event.keyCode == 27) {
    if ($(this).hasClass("open")) {
      $(this).trigger("click");
    }
    return false;
  }
});

$(document).ready(function () {
  create_custom_shortby_dropdown();
});

// show product per page
$(document).ready(function () {
  const showProductsPerPage = () => {
    jQuery(".sort-per-page select.num").on("change", function (e) {
      e.preventDefault();
      $("#resultLoading").show();
      let newUrlWithCount = updateURLParameter(window.location.href, "limit", jQuery(this).val());
      setTimeout(async function () {
        let productRes = await fetch(newUrlWithCount);
        productRes = await productRes.text();
        let parser = new DOMParser();
        let doc = parser.parseFromString(productRes, "text/html");
        let girdUpdate = doc.querySelector("#products-grid").innerHTML;
        document.querySelector("#products-grid").innerHTML = girdUpdate;
        let girdUpdate1 = doc.querySelector(".toolbar-bottom .collection-sorting-row").innerHTML;
        document.querySelector(".toolbar-bottom .collection-sorting-row").innerHTML = girdUpdate1;
        window.history.pushState({ path: newUrlWithCount }, "", newUrlWithCount);
        addToCart();
        __rt.enabled_wishlist?__kpWishlist(): null;
        productGridReview();
        $("#resultLoading").hide();
        showProductsPerPage();
      }, 500);
    });
  }
  showProductsPerPage();
});

function updateURLParameter(url, newKey, newValue) {
  let urlObj = new URL(url);
  urlObj.searchParams.set(newKey, newValue);
  return urlObj.toString();
}
